export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("vue:error", (error) => {
    if (error.statusCode === 500) {
      navigateTo("/");
    }
  });
});
